import {
    RESERVATION_STATUS_PENDING,
    RESERVATION_STATUS_HOLD,
} from '../../helpers/ReservationStatusConstants';
import TxpStrings from '../../schema/configSchema/TxpStrings';

/**
 * Utility function to retrieve the Reservation Status value from the blob value
 */
export default function getReservationStatus(
    reservationStatusBlobValue: string,
    txpStrings: TxpStrings
) {
    switch (reservationStatusBlobValue) {
        case RESERVATION_STATUS_PENDING:
            return txpStrings.strings.reservationPendingText;
        case RESERVATION_STATUS_HOLD:
            return txpStrings.strings.reservationHoldText;
        default:
            return null;
    }
}
